import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cx } from '../../../internal/cx.js';
/** Visual divider. `decorative` (default) hides it from assistive technology. */
export const Separator = forwardRef(function Separator({ className, orientation = 'horizontal', decorative = true, ...rest }, ref) {
    return (_jsx(SeparatorPrimitive.Root, { ref: ref, orientation: orientation, decorative: decorative, ...rest, className: cx('mn-separator', className) }));
});
//# sourceMappingURL=separator.js.map